export const EDIT_VARIATION = 'app/variations/EDIT_VARIATION';
export const RESET_VARIATION = 'app/variations/RESET_VARIATION';
export const VARIATION_REMOVED = 'app/variations/VARIATION_REMOVED';